import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, FormCurrency, FormDecidable } from "bm-ui-kit";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";

export interface StepFields {
	currentLoansMonthlyInstallment: number;
	creditLimitSumValue: number;
	inKHR: boolean;
}

export class Step7 extends AbstractStep<StepFields> {
	protected initValues(): StepFields {
		return {
			currentLoansMonthlyInstallment: undefined,
			creditLimitSumValue: undefined,
			inKHR: undefined,
		};
	}

	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		return (
			<>
				<Card.Body>
					<FormDecidable label="Szerepel bármelyik fél a KHR (BAR) listán?" name="inKHR" required />
					<FormCurrency
						label="Hány forint a jelenlegi hitelek összes havi törlesztőrészlete?"
						name="currentLoansMonthlyInstallment"
						infoTooltip="A háztartás összes havi törlesztőrészlete, pl. személyi kölcsön, áruhitel, diákhitel, autóhitel, munkáltatói kölcsön, lakáshitel, stb."
						placeholder="Ha nincs, írj be 0-át!"
						validate={this.validAmount}
						required
					/>
					<FormCurrency
						label="Hány forint a hitelkártyák, hitelkeretek teljes kihasználható kerete?"
						name="creditLimitSumValue"
						infoTooltip="A háztartás összes hitelkeretét bele kell számolni akkor is, ha nincs kihasználva."
						placeholder="Ha nincs, írj be 0-át!"
						validate={this.validAmount}
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</Button>
				</Card.Footer>
			</>
		);
	}

	private validAmount(amount: number): string {
		if (amount < 0) {
			return "Helytelen összeg!";
		}

		return undefined;
	}

	protected getComponentName(): string {
		return "Step7";
	}
}
